import { ViewContainerRef, ComponentRef, Component } from '@angular/core'
import { debounceTime } from 'rxjs'

import { SelectComponent } from '@satinel-system/form'

import { PatientDialogComponent } from '../../patient-dialog/patient-dialog.component'

@Component({
  selector: 'app-formly-patient',
  templateUrl: './patient-field.component.html'
})
export class PatientFieldComponent extends SelectComponent {
  patientDialog: ComponentRef<PatientDialogComponent> | undefined

  override get configItems() {
    return [
      ...(this.formControl?.value
        ? [
            {
              icon: 'fas fa-user',
              action: this.openPatientsWindow.bind(this)
            }
          ]
        : []),
      ...super.configItems
    ]
  }

  constructor(private vcr: ViewContainerRef) {
    super()
  }

  openPatientsWindow() {
    const idPaciente = this.formControl?.value
    if (this.patientDialog || !idPaciente) return
    this.patientDialog = this.vcr.createComponent(PatientDialogComponent)
    this.patientDialog.instance.idPaciente = idPaciente
    this.patientDialog.instance.visible = true
    const destroy = this.patientDialog.instance.destroy
      .pipe(debounceTime(200))
      .subscribe(() => {
        destroy?.unsubscribe()
        this.patientDialog?.destroy()
        this.patientDialog = undefined
        const mask = document.querySelector(
          '.p-dialog-mask.p-component-overlay.p-component-overlay-enter.p-dialog-mask-scrollblocker'
        )
        mask?.remove()
      })
  }
}
